// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iF0Up","title":"styles_title__2ctL3"};